import React from 'react';

export default () => <div className="separator">&nbsp;</div>;
